import { Accuracy, BusinessSecure, Efficiancy, FocusForward, Price, Scalability } from "../../../Components/BusinessIcons";
import ContainerSize from "../../../Components/container";
import SEO from "../../../Components/SEO";
import ServicesContent from "../../../Components/ServicesContent";
import ServicesCardInformation from "../ServicesCards";
const DigitalMarketingService = () => {

    const digitalMarketingKeywords = [
        "Digital Marketing Services USA",
        "Online Marketing Services USA",
        "SEO Services USA",
        "PPC Management USA",
        "Social Media Marketing USA",
        "Internet Marketing Company USA",
        "Digital Advertising USA",
        "Marketing Agency USA",
        "Local SEO services USA",
        "Paid search advertising USA",
        "Social media management for US businesses",
        "Lead generation services USA",
        "Email marketing services USA",
        "Content marketing services USA",
        "Marketing automation USA",
        "Digital marketing strategy USA",
        "Affordable digital marketing services for small businesses USA",
        "Best online marketing agency in the USA",
        "Digital marketing solutions for US startups",
        "SEO and PPC services for American businesses",
        "Social media advertising experts USA",
        "digital marketing services",
        "digital marketing agency",
        "online marketing services",
        "internet marketing company",
        "digital marketing company",
        "SEO services in texas",
        "social media marketing",
        "digital advertising in dallas",
        "online marketing agency",
        "content marketing services",
        "digital marketing agency USA",
        "online marketing services in USA",
        "PPC agency USA",
        "internet marketing services USA",
        "content marketing agency USA",
        "marketing strategy services USA",
        "SEO agencies",
        "social media marketing agencies",
        "digital marketing consultant",
        "best digital marketing agencies",
        "full-service marketing agency",
        "PPC agencies",
        "content marketing agencies",
        "digital marketing firms",
        "marketing strategy agencies",
        "digital marketing agency for small businesses",
        "best digital marketing services for small businesses",
        "affordable digital marketing agency USA",
        "digital marketing for startups USA",
        "professional SEO and PPC services",
        "local SEO services for US businesses",
        "social media ad management services USA",
        "lead generation services for US companies",
        "email and content marketing solutions USA",
        "ecommerce digital marketing services USA",
        "local digital marketing experts USA",
        "e-commerce digital marketing agency for startups",
        "white-label digital marketing services US-based",
        "affordable local seo packages for small business",
        "hire fractional CMO for digital marketing",
        "outsource PPC management services USA",
        "average cost of digital marketing services 2026",
        "in-house vs outsourced digital marketing team",
        "what does a full-service digital marketing agency do",
        "b2b lead generation digital marketing strategies",
        "clutch top digital marketing agencies usa",
        "google premier partner marketing agency near me",
        "minority-owned digital marketing agency us"

    ];

    const cardItems = [
        {
            icon: (
                <BusinessSecure />
            ),
            title: 'SEO Precision',
            description: `We don't just find traffic; we find your customers. By focusing on geo-specific keywords and high-intent search terms within the US market, we ensure your business ranks where it matters most right in front of your target audience.`
        },
        {
            icon: (
                <FocusForward />
            ),
            title: '2. Scalable Web Architecture',
            description:
                'Whether you are a startup looking for your first digital footprint or a large-scale industry leader needing a complex enterprise solution, our websites are built to grow. We create responsive, high-performance sites that handle 100 visitors or 100,000 without breaking a sweat.'
        }, {
            icon: (
                <Price />

            ),
            title: 'Data-Driven Strategy',
            description:
                `Marketing shouldn't be a guessing game. We use advanced analytics to track every click, call and conversion. Our strategy evolves based on real-time US market trends, ensuring your budget is always invested in the highest-performing channels.`
        },
        {
            icon: (
                <Scalability />

            ),
            title: 'Local & National Authority',
            description:
                'We build your digital reputation from the ground up. Through strategic backlinking and Google Business Profile optimization, we help small businesses dominate their local "near me" searches while helping large industries establish nationwide brand authority.',
        },
        {
            icon: (
                <Efficiancy />

            ),
            title: 'Conversion-First Design',
            description:
                `A beautiful website is useless if it doesn't sell. Our "Conversion Rate Optimization" (CRO) focus ensures that every element of your site, from the copy to the "Call to Action" buttons, is engineered to turn casual browsers into loyal clients.`
        },
        , {
            icon: (
                <Accuracy />

            ),
            title: 'Content Excellence',
            description:
                `In the world of SEO, content is still king. We produce high-quality, English-native content that resonates with American consumers. From blog posts to technical white papers, we speak your customers' language and satisfy search engine algorithms simultaneously.`
        },
    ];
    const servicesCardData = [
        {
            heading: "SEO Optimization",
            descriptions: `
Search Engine Optimization (SEO) improves website visibility across search engines in the USA.
Our SEO strategies include on-page, technical and off-page optimization.
Answer Engine Optimization (AEO) positions content for featured snippets and AI search results.
Generative Engine Optimization (GEO) increases visibility on AI-powered search platforms.
We conduct keyword research aligned with US search intent.
Local and national SEO services support businesses across the United States.
Content optimization strengthens relevance, authority and user experience.
Performance tracking drives ongoing optimization and sustainable growth.`
        },
        {
            heading: "PPC Advertising",
            descriptions: `
PPC advertising drives targeted traffic for USA businesses through paid search campaigns. We manage Google Ads and Microsoft Ads across the United States. Campaigns focus on high-intent keywords and user behavior. Ad copy and landing pages are optimized for relevance and quality score. Strategic budget management delivers efficient ad spend. Conversion tracking captures leads, calls and form submissions. Ongoing optimization increases click-through rates and engagement. Data-driven reporting supports confident marketing decisions.
`

        },
        {
            heading: "Social Media Marketing",
            descriptions: `Social Media Marketing builds brand presence and audience engagement for US businesses.
We manage platforms including Facebook, Instagram, LinkedIn and X.
Content strategies align withUS audience behavior and trends.
Organic and paid social campaigns support consistent brand visibility.
Creative content increases reach, engagement and interaction.
Audience targeting connects brands with relevant users across the United States.
Performance tracking measures engagement and campaign impact.
Ongoing optimization supports steady growth and brand consistency.  
`
        },
        {
            heading: "Content Marketing",
            descriptions: `Content Marketing helpsUS businesses attract, engage and convert audiences.
We create blogs, articles, videos and infographics tailored toUS markets.
SEO-focused content improves visibility on Google and other search engines.
Answer Engine Optimization (AEO) enhances content for AI search results.
Generative Engine Optimization (GEO) boosts content performance on AI-powered platforms.
Social media content drives engagement across Facebook, Instagram, LinkedIn and X.
Email campaigns deliver personalized content toUS audiences.
Performance tracking measures traffic, leads and conversions.
Ongoing strategy updates keep content relevant and competitive acrossUS industries`
        },
        {
            heading: "Web Design & Conversion Optimization",
            descriptions: `Web Design & Conversion Optimization helps USA. businesses create responsive, user-friendly websites. We design websites optimized for performance, speed and mobile devices. Custom layouts showcase your brand and engage visitors effectively. Conversion-focused design increases lead generation and sales. SEO and AEO best practices enhance search visibility. GEO strategies boost content performance on AI-powered platforms. Landing pages are optimized for clear calls-to-action and higher conversions. Analytics tracking measures user behavior and identifies improvement opportunities. Continuous testing and optimization maximize ROI for USA businesses.`
        }
    ];
    return (
        <>
            <SEO
                title="Digital Marketing & Web Design Services for US Businesses"
                description="Grow your US business with expert digital marketing services. We offer SEO, PPC, social media marketing, and tailored strategies to boost leads & sales."
                keywords={digitalMarketingKeywords.join(",")}

            />
            <ServicesContent servicesCardData={servicesCardData} />
            <ContainerSize>
                <ServicesCardInformation cardItems={cardItems} />
            </ContainerSize>
        </>
    )
}
export default DigitalMarketingService